/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingCancellationDto
 */
export interface BookingCancellationDto {
    /**
     * Цена отмены бронирования, если отмена бесплатна значение - null
     * @type {number}
     * @memberof BookingCancellationDto
     */
    penalty?: number | null;
    /**
     * Возможность отмены бронирования
     * @type {boolean}
     * @memberof BookingCancellationDto
     */
    status: boolean;
    /**
     * Дата, до которой возможна отмена бронирования
     * @type {string}
     * @memberof BookingCancellationDto
     */
    date?: string | null;
}

/**
 * Check if a given object implements the BookingCancellationDto interface.
 */
export function instanceOfBookingCancellationDto(value: object): value is BookingCancellationDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BookingCancellationDtoFromJSON(json: any): BookingCancellationDto {
    return BookingCancellationDtoFromJSONTyped(json, false);
}

export function BookingCancellationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingCancellationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'penalty': json['penalty'] == null ? undefined : json['penalty'],
        'status': json['status'],
        'date': json['date'] == null ? undefined : json['date'],
    };
}

  export function BookingCancellationDtoToJSON(json: any): BookingCancellationDto {
      return BookingCancellationDtoToJSONTyped(json, false);
  }

  export function BookingCancellationDtoToJSONTyped(value?: BookingCancellationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'penalty': value['penalty'],
        'status': value['status'],
        'date': value['date'],
    };
}

